import { FcPrivacy, FcServices } from 'react-icons/fc';
import { MdCookie } from 'react-icons/md';

type LegalSection = {
  id: string;
  title: string;
  description: string;
  icon: React.ElementType;
};

export const legalSections = (t: any): LegalSection[] => {
  return [
    {
      id: 'privacy',
      title: t('legal.privacy'),
      description: t('legal.privacy-description'),
      icon: FcPrivacy
    },
    {
      id: 'terms',
      title: t('legal.terms'),
      description: t('legal.terms-description'),
      icon: FcServices
    },
    {
      id: 'cookies',
      title: t('legal.cookies'),
      description: t('legal.cookies-description'),
      icon: MdCookie
    }
  ];
};
